export const PATHS = {
  HOME: '/',
  COMPANY: '/company/:companyId',
  SEARCH_REDIRECT_ORDER: '/:trackingCode',
  SEARCH_REDIRECT_ORDER_SURVEY: '/:trackingCode/survey',
  ORDER: '/company/:companyId/order/:trackingCode',
  SURVEY: '/company/:companyId/order/:trackingCode/survey',
};

export const EXTERNALS_URLS = {
  HELP_ARTICLE: 'https://routix.tawk.help/article/seguimiento-de-visitas',
  COMMERCIAL_PAGE: 'http://routix.io',
};
